import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './PastProjectTableComponent.module.scss';
import metadata from './PastProjectTableComponent.metadata.json5';

function PastProjectTableComponent(props) {

    const {
        data: PastProjectTableVM,
        updateWizardData,
        submissionVM,
        PastProjectTablePath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    PastProjectTableVM.isValidationReq = true;

    const addPastProjectTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PastProjectTableVM.value = PastProjectTableVM.value || []

            const { _xCenter, _dtoName } = PastProjectTableVM;

            const PastProjectTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PastProjectTableObjVM.isValidationReq.value = true

            PastProjectTableVM.pushElement(
                PastProjectTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PastProjectTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PastProjectTableVM.value.splice(index, 1);
            _.set(submissionVM.value, PastProjectTablePath, PastProjectTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PastProjectTablePath, PastProjectTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'jobSiz1') {
                const value = (item && item.jobSiz1) ? item.jobSiz1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = PastProjectTableVM.length > 0 && PastProjectTableVM.children[index].jobSiz1
                    // eslint-disable-next-line security/detect-object-injection
                    ? PastProjectTableVM.children[index].jobSiz1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.jobSiz1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'desOfSerPer2') {
                const value = item.desOfSerPer2 ? item.desOfSerPer2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desOfSerPer2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'conVal3') {
                const value = item.conVal3 ?? '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.conVal3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={9999999999}
                    />
                );
            }

            if (path === 'proFee4') {
                const value = item.proFee4 ?? '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.proFee4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={9999999999}
                    />
                );
            }
        }, [handleValueChange, translator, PastProjectTableVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PastProjectTableTable`]: {
            data: PastProjectTableVM.value,
        }

    }), [PastProjectTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPastProjectTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PastProjectTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PastProjectTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PastProjectTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PastProjectTableComponent.propTypes = wizardProps;
export default withRouter(PastProjectTableComponent);
